module.exports = __webpack_public_path__ + "img/background_main_game.bdc865e9.png";